import { useEffect, useMemo, useState } from 'react';
import useZStore from '../useZStore';
import { isEqual } from 'lodash';

type Slice = 'bookmarked' | 'for_study';

// TO-DO: I believe this could be done inside zustand
export const useSlicedNotes = (slice: Slice) => {
  const userNotes = useZStore((state) => state.userNotes);
  const [slicedIds, setSlicedIds] = useState<string[]>([]);

  const newSlicedNoteIds = useMemo(
    () =>
      Object.values(userNotes)
        .filter((userNote) => userNote[slice])
        .map((userNote) => userNote.example_id)
        .sort(),
    [userNotes, slice],
  );

  useEffect(() => {
    if (!isEqual(slicedIds, newSlicedNoteIds)) {
      setSlicedIds(newSlicedNoteIds);
    }
  }, [newSlicedNoteIds, slicedIds]);

  return slicedIds;
};
